import { combineReducers } from 'redux';

const infoInitialState = {
  data: null,
  loadStatus: 0,
};

const userInitialState = {
  data: null,
  loadStatus: 0,
};

const editInitialState = {
  data: null,
  saveStatus: 0,
  input: {
    code: '',
  },
};

const userInfoInitialState = {
  data: null,
  loadStatus: 0,
};

const editPhoneInitialState = {
  data: null,
  saveStatus: 0,
  input: {
    phone: '',
  },
};

function infoReducer(state = infoInitialState, action) {
  switch (action.type) {
    case 'LOAD_SHARE_CODE_INFO': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_SHARE_CODE_INFO_COMPLETION': {
      return {
        ...state,
        loadStatus: 2,
        data: action.data,
      };
    }

    case 'UPDATE_SHARE_CODE_COMPLETION': {
      if (action.error) {
        return {
          ...state,
        };
      }

      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
      };
    }

    default:
      return state;
  }
}

function userReducer(state = userInitialState, action) {
  switch (action.type) {
    case 'LOAD_INFO_BY_SHARE_CODE': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'SYNC_SHARE_CODE_EDIT_INPUT': {
      return {
        ...state,
        ...(action.reset && userInitialState),
      };
    }

    case 'LOAD_INFO_BY_SHARE_CODE_COMPLETION': {
      return {
        ...state,
        loadStatus: 2,
        data: action.data,
      };
    }

    default:
      return state;
  }
}

function editReducer(state = editInitialState, action) {
  switch (action.type) {
    case 'SYNC_SHARE_CODE_EDIT_INPUT': {
      return {
        ...state,
        input: {
          ...(action.reset && !action.input
            ? editInitialState.input
            : state.input),
          ...action.input,
        },
      };
    }

    case 'UPDATE_SHARE_CODE': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'UPDATE_SHARE_CODE_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          saveStatus: -1,
        };
      }
      return {
        ...state,
        saveStatus: 2,
        data: action.data,
      };
    }

    default:
      return state;
  }
}

function userInfoReducer(state = userInfoInitialState, action) {
  switch (action.type) {
    case 'LOAD_INFO_BY_PHONE_NUMBER': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'SYNC_MANAGER_PHONE_EDIT_INPUT': {
      return {
        ...state,
        ...(action.reset && userInfoInitialState),
      };
    }

    case 'LOAD_INFO_BY_PHONE_NUMBER_COMPLETION': {
      return {
        ...state,
        loadStatus: 2,
        data: action.data,
      };
    }

    default:
      return state;
  }
}

function editPhoneReducer(state = editPhoneInitialState, action) {
  switch (action.type) {
    case 'SYNC_MANAGER_PHONE_EDIT_INPUT': {
      return {
        ...state,
        input: {
          ...(action.reset && !action.input
            ? editPhoneInitialState.input
            : state.input),
          ...action.input,
        },
      };
    }

    case 'EDIT_MANAGER_PHONE': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'EDIT_MANAGER_PHONE_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          saveStatus: -1,
        };
      }
      return {
        ...state,
        saveStatus: 2,
        data: action.data,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  info: infoReducer,
  user: userReducer,
  edit: editReducer,
  userInfo: userInfoReducer,
  editPhone: editPhoneReducer,
});
